import React from 'react';
import { DialogForm } from '../../components/DialogForm';
import { Checkbox, Grid, Select, Typography, MenuItem, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const retryFrequencies = [
  { value: 0, label: '0' },
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 5, label: '5' },
  { value: 10, label: '10' },
  { value: 15, label: '15' },
  { value: 30, label: '30' },
  { value: 60, label: '60' }
];

const maxRetries = [
  { value: 0, label: '0' },
  { value: 5, label: '5' },
  { value: 10, label: '10' },
  { value: 25, label: '25' },
  { value: 50, label: '50' }
];

const useStyle = makeStyles(theme => ({
  select: {
    width: '50%'
  },
  content: {
    textAlign: 'center'
  },
  grid: {
    width: '100%',
    borderBottom: '1px solid #EBEBEB'
  }
}));

const ServiceSettingsDialog = (props: any) => {
  const { isOpen, handleDialogClose, rowData, formInfo, handleOperationDataChange, handleDialogSubmit } = props;
  const classes = useStyle();

  return (
    <DialogForm
      openFn={isOpen}
      dataConfig={[]}
      handleDialogClose={handleDialogClose}
      handleDialogSubmit={() => handleDialogSubmit(props.formData)}
      submitlabel={'Save'}
      title={`${rowData?.workflowName || ''} Settings`}
      dialogId="service-settings-id"
      closeFn={handleDialogClose}
      supportUser={props.supportUser}
    >
      <>
        <Box className={classes.grid}>
          <Grid container spacing={3} alignItems="flex-end">
            <Grid item xs={4} justify="center" alignItems="flex-end">
              <Typography noWrap>Name</Typography>
            </Grid>
            <Grid item xs={2} justify="center" alignItems="flex-end">
              <Typography noWrap>Custom Retry</Typography>
            </Grid>
            <Grid item xs={3} justify="center" alignItems="flex-end">
              <Typography>Retry Frequency</Typography>
            </Grid>
            <Grid item xs={3} justify="center" alignItems="flex-end">
              <Typography>Maximum retries</Typography>
            </Grid>
          </Grid>
        </Box>
        {Object.keys(formInfo?.operations || {}).map((operationCode: any) => (
          <Grid container spacing={3} alignItems="flex-end">
            <Grid item xs={4} justify="center" alignItems="flex-end">
              <Typography noWrap>{formInfo.operations[operationCode].operationName}</Typography>
            </Grid>
            <Grid item xs={2} justify="center" alignItems="flex-end">
              <Checkbox
                data-id="autoRetry"
                checked={formInfo?.operations?.[operationCode] ? formInfo.operations[operationCode].autoRetry : false}
                onChange={e => handleOperationDataChange(e, operationCode, 'autoRetry')}
                name="autoRetry"
                color="primary"
                disabled={props?.supportUser}
              />
            </Grid>
            <Grid item xs={3} justify="center" alignItems="flex-end">
              <Select
                id="retry-frequency-Select"
                className={classes.select}
                label={'Retry Frequency'}
                value={formInfo.operations[operationCode]?.retryFrequency || 0}
                disabled={props?.supportUser ? props?.supportUser : !formInfo.operations[operationCode]?.autoRetry}
                onChange={e => handleOperationDataChange(e, operationCode, 'retryFrequency')}
              >
                {retryFrequencies?.map((item, key) => (
                  <MenuItem key={key} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs={3} justify="center" alignItems="flex-end">
              <Select
                id="maximum-retry-Select"
                className={classes.select}
                label={'Maximum Retries'}
                value={formInfo.operations[operationCode].maxRetries || 0}
                disabled={props?.supportUser ? props?.supportUser : !formInfo.operations[operationCode]?.autoRetry}
                onChange={e => handleOperationDataChange(e, operationCode, 'maxRetries')}
              >
                {maxRetries?.map((item, key) => (
                  <MenuItem key={key} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid>
        ))}
      </>
    </DialogForm>
  );
};

export default ServiceSettingsDialog;
